import { render, staticRenderFns } from "./RealVideoMediasoup.vue?vue&type=template&id=5d265c9e&scoped=true"
import script from "./RealVideoMediasoup.vue?vue&type=script&lang=js"
export * from "./RealVideoMediasoup.vue?vue&type=script&lang=js"
import style0 from "./RealVideoMediasoup.vue?vue&type=style&index=0&id=5d265c9e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d265c9e",
  null
  
)

export default component.exports